// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactItem_wrapper__VSLI6","link":"ContactItem_link__ZdFCr","icon":"ContactItem_icon__04PeB"};